import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faFile, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { Col, Form, FormLabel, Row, Button, Spinner, FormCheck } from "react-bootstrap";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { FrontEndRoutes } from "../../config/front-end-routes";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DateForm from "../../Components/Form/DateForm";
import FormCheckInput from "react-bootstrap/esm/FormCheckInput";
import PedidoInfo from "./PedidoInfo";
import ClienteInfo from "./ClienteInfo";
import PrazoPagamento from "./PrazoPagamento";
import GridPedidos from "../Grid/GridPedidos";
import TotalPedido from "./TotalPedido";
import ModalAdicionarItem from "../Modal/ModalAdicionarItem";
import FloatingButton from "../Buttons/FloatingButton";

interface Produto {
  modelo: string;
  descricao: string;
  grade: { [key: string]: number };
  qtd_total: number;
  preco: number;
  total: number;
}

interface GridPedidosProps {
  data: Produto[];
  setData: React.Dispatch<React.SetStateAction<Produto[]>>;
}


const FormPedido: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams<{ id: string }>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [produtos, setProdutos] = useState<Produto | null>(null);
  const [discount, setDiscount] = useState({
    valor_desconto: "",
    porc_desconto: "",
    total_bruto: "",
    total: "",
    num_peca: 0,
  })
  const [formData, setFormData] = useState({
    codigo_pedido: "",
    id_vendedor: "",
    cnpj_cliente: "",
    id_tabela: "",
    criterio: "",
    nr_pedido: "",
    ordem_compra: "",
    status: "0",
    razao: "",
    data_emissao: "",
    previsao_entrega: "",
    observacao: "",
    prazo_pagto: "",
    flg_entrega_antes_prazo: 0,
    flg_entrega_parcial: 0,
  });


  const [errors, setErrors] = useState({
    nr_pedido: "",
    cnpj_cliente: "",
    ordem_compra: "",
    status: "",
    data_emissao: "",
    previsao_entrega: "",
    razao: "",
  });

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    let errorMessage = "";
    if (!value) {
      errorMessage = "Este campo é obrigatório.";
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: errorMessage,
    }));
  };

  const handleChange = (e: any) => {
    const { id, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: "",
    }));
    console.log(formData)
  };

  const saveFunction = (e: React.FormEvent<any>) => {
    e.preventDefault();
    // Inicializa um objeto de erros
    const newErrors: Record<keyof typeof formData, string> = {
      cnpj_cliente: "",
      criterio: "",
      id_vendedor: "",
      id_tabela: "",
      codigo_pedido: "",
      nr_pedido: "",
      ordem_compra: "",
      status: "",
      razao: "",
      data_emissao: "",
      previsao_entrega: "",
      observacao: "",
      prazo_pagto: "",
      flg_entrega_antes_prazo: "",
      flg_entrega_parcial: "",
    };

    // Validação de campos obrigatórios
    if (!formData.nr_pedido) newErrors.nr_pedido = "N° do Pedido é obrigatório.";
    if (!formData.ordem_compra) newErrors.ordem_compra = "Ordem de Compra é obrigatória.";

    // Atualiza estado de erros se houver algum
    const hasErrors = Object.values(newErrors).some((error) => error);
    if (hasErrors) {
      setErrors(newErrors);
      toast.error("Erros encontrados no formulário. Por favor, corrija.");
      return;
    }

    // Limpa os erros (caso exista algum anteriormente) e salva os dados
    setErrors({
      cnpj_cliente: "",
      nr_pedido: "",
      ordem_compra: "",
      status: "",
      data_emissao: "",
      previsao_entrega: "",
      razao: "",
    });
    handleSave();
  };

  const handleSave = () => {
    try {
      const data = {
        cnpj_cliente: formData.cnpj_cliente,
        id_vendedor: '5',
        nr_pedido: formData.nr_pedido,
        data_emissao: formData.data_emissao,
        previsao_entrega: formData.previsao_entrega,
        observacao: formData.observacao,
        flg_entrega_antes_prazo: formData.flg_entrega_antes_prazo,
        flg_entrega_parcial: formData.flg_entrega_parcial,
        nr_ordem_compra: formData.ordem_compra
      };

      setLoading(true);

      const request = id
        ? api.put(BackEndRoutes.routes.PEDIDOS.UPDATE.replace(":id", id), data)
        : api.post(BackEndRoutes.routes.PEDIDOS.POST, data);

      request
        .then((response) => {
          toast.success("Pedido salvo com sucesso!");
          navigate(FrontEndRoutes.PEDIDOS.EDIT.replace(":id", response.data.id_pedido));
          console.log(data)
        })
        .catch((error) => {
          console.error("Erro ao salvar Pedido:", error);
          toast.error("Falha ao salvar pedido. Por favor, tente novamente.");
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Erro inesperado:", error);
      toast.error("Ocorreu um erro inesperado.");
      setLoading(false);
    }
  };

  const getData = () => {
    setLoading(true);

    api.get(BackEndRoutes.routes.PEDIDOS.EDIT.replace(":id", id))
      .then((response) => {
        const data = response.data;
        setFormData((prevData) => ({
          ...prevData,
          codigo_pedido: data.id_pedido || "",
          nr_pedido: data.nr_pedido || "",
          ordem_compra: data.nr_ordem_compra || "",
          status: data.flg_concluido || "0",
          data_emissao: data.data_emissao || "",
          previsao_entrega: data.previsao_entrega || "",
          observacao: data.observacao || "",
          prazo_pagto: data.prazo_pagto || "",
          cnpj_cliente: data.cnpj_clifor || "",
          razao: data.cliente.razao || "",
          id_tabela: data.cliente.id_tabela || "",
          flg_entrega_antes_prazo: data.flg_entrega_antes_prazo ?? 0,
          flg_entrega_parcial: data.flg_entrega_parcial ?? 0,
        }));

        const totalPecas = data.itens?.reduce((acc: number, item: any) => acc + (item.quantidade || 0), 0) || 0;

        setDiscount({
          valor_desconto: data.valor_desconto || "",
          porc_desconto: data.porc_desconto || "",
          total_bruto: data.total_bruto || "",
          total: data.total || "",
          num_peca: totalPecas || 0,
        });

        setProdutos(data?.itens);
        getItens();
      })
      .catch((error) => {
        console.error("Erro ao buscar o pedido", error);
        toast.error("Falha ao buscar pedido. Por favor, tente novamente.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getItens = () => {
    setLoading(true);

    api.get(`${BackEndRoutes.routes.PEDIDOS.ITENS.LIST}?id_pedido=${id}`)
      .then((response) => {
        setProdutos(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar os itens do pedido", error);
        toast.error("Falha ao buscar itens do pedido. Por favor, tente novamente.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (id) {
      getData()
    }
  }, [id])

  return (
    <div className="card">
      <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
        <FontAwesomeIcon icon={faFile} className="fa-2xl mb-2" />
        <h2>{!id ? "NOVO PEDIDO" : "EDITAR PEDIDO"}</h2>
      </div>
      <Form className="m-4" onSubmit={saveFunction}>

        <PedidoInfo
          id={id}
          errors={errors}
          formData={formData}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />

        <ClienteInfo
          id={id}
          errors={errors}
          formData={formData}
          setFormData={setFormData}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />

        <DateForm
          id={id}
          setFormData={setFormData}
          formData={formData}
          handleBlur={handleBlur}
          handleChange={handleChange}
          errors={errors}
        />

        <FormCheck className="mt-4">
          <FormCheck.Label className="d-flex gap-2">
            <FormCheck.Input
              type="checkbox"
              id="flg_entrega_antes_prazo"
              name="flg_entrega_antes_prazo"
              checked={formData.flg_entrega_antes_prazo === 1}
              onChange={(e) =>
                setFormData({ ...formData, flg_entrega_antes_prazo: e.target.checked ? 1 : 0 })
              }
            />
            Permite entrega Parcial
          </FormCheck.Label>

          <FormCheck.Label className="d-flex gap-2 mt-2">
            <FormCheck.Input
              type="checkbox"
              id="flg_entrega_parcial"
              name="flg_entrega_parcial"
              checked={formData.flg_entrega_parcial === 1}
              onChange={(e) =>
                setFormData({ ...formData, flg_entrega_parcial: e.target.checked ? 1 : 0 })
              }
            />
            Autorizo entrega antes do prazo porém com data base.
          </FormCheck.Label>
        </FormCheck>


        {!id ? <>
          <div className="d-flex row " style={{ background: '#FFFFE0' }}>
            <div className="m-3 ">
              <div className="d-flex align-items-center gap-2 justify-content-start">
                <FontAwesomeIcon icon={faSave} className="fa-xl mb-2" style={{ color: '#808000' }} />
                <h4 style={{ color: '#808000' }}>Atenção!</h4>
              </div>
              <p style={{ color: '#808000' }}>Para dar continuidade no pedido é necessário salva-lo!</p>
            </div>
          </div></>
          : <>
            <Row>
              <GridPedidos
                data={produtos || []}
                setData={setProdutos}
                reload={getData}
                tabela={formData.id_tabela}
              />
            </Row>
            <Row className="mt-3">
              <TotalPedido
                data={discount}
                setData={setDiscount}
              />
            </Row>
          </>
        }

        <Row className="mt-3">
          <PrazoPagamento
            data={formData}
            setData={setFormData}
          />
        </Row>

        <Row className="mt-3">
          <Col>
            <div className="d-flex align-items-center gap-2 justify-content-start">
              <FontAwesomeIcon icon={faCommentDots} className="fa-xl mb-2" />
              <h4>Observações</h4>
            </div>
            <textarea
              id="observacao"
              className="form-control"
              placeholder="Deixe uma observação"
              style={{ height: '150px' }}
              value={formData.observacao}
              onChange={handleChange}
            />
          </Col>
        </Row>

        <ModalAdicionarItem
          show={showModal}
          setShow={setShowModal}
          reload={getData}
          tabela={formData.id_tabela}
          onCancel={() => setShowModal(false)}
        />

        <FloatingButton
          id={id}
          setShowModal={setShowModal}
        />



        <div className="d-flex justify-content-center gap-4">
          <Button
            type="button"
            className="mt-3 col-lg-2 col-5"
            variant="secondary"
            disabled={loading}
            onClick={() => navigate(FrontEndRoutes.PEDIDOS.LIST)}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Voltar"}
          </Button>

          <Button type="submit" className="mt-3 col-lg-2 col-5" disabled={loading} onClick={saveFunction}>
            {loading ? <Spinner animation="border" size="sm" /> : "Salvar"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormPedido;
